import styled from "styled-components";

export const Link = styled.a`
  display: block;
  margin-top: 1rem;
`
